import './DatePickerComponent.scss'
import React, {useCallback, useEffect, useState} from 'react';
import FormControl from "@mui/material/FormControl";
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {FormHelperText} from "@mui/material";
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import moment, {Moment} from "moment";

interface DatePickerComponentProps {
    name: string;
    id?: string;
    label?: string;
    placeholder?: string;
    minDate?: Moment;
    maxDate?: Moment;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    variant?: "filled" | "standard" | "outlined" | undefined;
    color?: "primary" | "error" | "secondary" | "info" | "success" | "warning" | undefined;
    onDateChange?: Function;
    hasError?: boolean;
    errorMessage?: any;
    value?: any;
    fullWidth?: boolean;
    mask?: string;
    size?: "small" | "medium" | undefined;
}

const DatePickerComponent = (props: DatePickerComponentProps) => {

        const [value, setValue] = useState<Date | any>(undefined);

        const [open, setOpen] = useState<boolean>(false);
        const {
            name,
            id,
            label,
            disabled,
            readOnly,
            required,
            minDate,
            hasError,
            errorMessage,
            size,
            fullWidth,
        } = props;

        let {placeholder, color, variant, mask, maxDate, onDateChange} = props;
        if (!placeholder) placeholder = label;
        if (!color) color = "secondary";
        if (!variant) variant = "outlined";
        if (!mask) mask = "__/__/____";

        const handleChange = useCallback((newValue: Date | null) => {
            setValue(newValue)
            if (onDateChange) onDateChange(newValue);
        }, [onDateChange, setValue]);

        useEffect(() => {
            if (props.value) {
                setValue(props.value);
            } else {
                setValue(null);
            }
        }, [props.value]);

        return (
            <FormControl variant={variant}
                         className="input-component-wrapper"
                         fullWidth={fullWidth}
                         size={size}
                         error={hasError}
                         sx={{
                             "& .MuiOutlinedInput-root": {
                                 background: "#FAFAFA"
                             }
                         }}
            >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label={label}
                        // mask={mask}
                        // inputFormat={'MM/dd/yyyy'}
                        format={'MM/dd/yyyy'}
                        minDate={minDate && minDate.toDate()}
                        maxDate={maxDate && maxDate.toDate()}
                        readOnly={readOnly}
                        value={value ? moment(value, "YYYY-MM-DD").toDate() : undefined}
                        open={open}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        disabled={disabled}
                        onChange={handleChange}
                        //new version code
                        slotProps={{
                            textField: {
                                required: required,
                                placeholder: placeholder,
                                error: hasError,
                                name: name,
                                id: id,
                                color: color,
                                onClick: () => setOpen(!disabled)
                            },
                        }}
                        //old version code "@mui/x-date-pickers": "^6.9.2"
                        // renderInput={(params: any) => <TextField
                        //     sx={{
                        //         "& .MuiOutlinedInput-root": {
                        //             background: "#FAFAFA"
                        //         }
                        //     }
                        //     }
                        //     required={required}
                        //     id={id}
                        //     size={size}
                        //     name={name}
                        //     onClick={(e) => setOpen(true)}
                        //     color={color}
                        //     placeholder={placeholder}
                        //     {...params}
                        //     error={hasError}
                        // />}
                    />
                </LocalizationProvider>
                <FormHelperText>
                    {hasError && errorMessage}
                </FormHelperText>
            </FormControl>
        )
    }

;

export default DatePickerComponent;
